import type { Dispatch } from 'react';
import { useDebriefV2State } from '../../shared/context/DebriefV2StateContext';
import type { DeepDiveAction, DeepDiveState } from '../types/deepDive.types';

export function useDeepDiveState(): {
  state: DeepDiveState;
  dispatch: Dispatch<DeepDiveAction>;
} {
  return useDebriefV2State().deepDive;
}
